import React from 'react';
import './App.css';
import './Animations.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import TopMenu from "./Components/TopMenu2";
import MainSlider from "./Components/Slider";
import Content from "./Components/Content2";
import { BrowserRouter as Router } from 'react-router-dom';

function App() {

    return (
        <Router>
            <div className="App">
                <TopMenu/>
                <MainSlider/>
                <Content/>
            </div>
        </Router>
    );
}

export default App;
